import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Notification } from 'components/CustomNotification';
import {
  SubmitContainer,
  ExperienceList,
  ExperienceContainer,
} from 'pages/addprofile/Profile.style';
import {
  Input,
  Button,
  BasicIconButton,
  BrandIconSpinner,
  Select,
} from 'components';
import {
  InsertEducation,
  updateEducationList,
  deleteEducation,
  getEducationByuserId,
} from 'redux/features/EducationSlice';
import { MonthList, ProfileLimit, YearList } from 'assert/OptionList';
import CheckBox from 'components/CheckBox';
import moment from 'moment';

import { ReactComponent as Delete } from 'assert/images/More/delete.svg';
import { ReactComponent as EditFilled } from 'assert/images/Profile/edit.svg';
import { ReactComponent as BackArrow } from 'assert/images/Common/backArrow.svg';
import { ReactComponent as Exclamation } from 'assert/images/Common/exclamation.svg';
import BasicPopover from 'components/Popover';
import { JobAlertPopover } from 'pages/jobs/JobPosts.style';

const Educations = ({
  educationList,
  educationsData,
  changeAction,
  changeTitle,
  onClose,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [educationID, setEducationId] = useState(null);
  const [enableSubmit, setEnableSubmit] = useState(null);
  const [isAlertPopoverOpen, setIsAlertPopoverOpen] = useState(false);
  const [educationDetails, setEducatiobDetails] = useState({
    schoolCollege: '',
    degree: '',
    fieldOfStudies: '',
    startMonth: '',
    startYear: '',
    endMonth: '',
    endYear: '',
    currentlyStudying: false,
    otherDetails: '',
  });

  const [errMsg, setErrmsg] = useState({
    schoolCollege: '',
    degree: '',
    startMonth: '',
    startYear: '',
    endMonth: '',
    endYear: '',
  });

  const resetFields = () => {
    Object.keys(educationDetails).forEach((data) => {
      educationDetails[data] = '';
    });
    Object.keys(errMsg).forEach((data) => {
      errMsg[data] = '';
    });
    setEdit(false);
    setEducatiobDetails((prevState) => ({
      ...prevState,
    }));
    setErrmsg((prevState) => ({
      ...prevState,
    }));
    // educationList('', 'education');
    setEnableSubmit(null);
    setLoading(false);
    onClose(false, 'education');
  };

  useEffect(() => {
    if (enableSubmit !== null) {
      const validation = Object.keys(errMsg).every((it) => errMsg[it] === '');
      if (validation) {
        setLoading(true);
        const payload = {
          createdById: getProfile?.userId,
          schoolCollege: educationDetails.schoolCollege,
          degree: educationDetails.degree,
          fieldOfStudies: educationDetails.fieldOfStudies,
          startDate:
            educationDetails.startMonth + '/' + educationDetails.startYear,
          endDate: (educationDetails.currentlyStudying !== true && educationDetails.endMonth) ? educationDetails.endMonth + '/' + educationDetails.endYear : "",
          currentlyStudying: Boolean(educationDetails.currentlyStudying),
          otherDetails: educationDetails.otherDetails
        };
        dispatch(
          educationsData?.title === 'Edit'
            ? updateEducationList(payload, educationID)
            : InsertEducation(payload)
        )
          .then(() => {
            dispatch(getEducationByuserId());
            resetFields();
            Notification(
              'success',
              educationsData?.title === 'Edit'
                ? 'Updated Successfully'
                : 'Added Successfully'
            );
          })
          .catch(() => {
            resetFields();
            Notification('error', 'Something went wrong');
          });
      }
    }
  }, [enableSubmit, educationID]);

  const handleChange = useCallback(
    (data, name) => {
      setEducatiobDetails((prevState) => ({
        ...prevState,
        [name]: data,
      }));
    },
    [educationDetails]
  );

  const handleValidation = useCallback(() => {
    const validationParams = { ...errMsg };
    if (!educationDetails.schoolCollege?.trim())
      validationParams.schoolCollege = 'School is required';
    else validationParams.schoolCollege = '';

    if (!educationDetails.degree?.trim())
      validationParams.degree = 'Degree is required';
    else validationParams.degree = '';

    if (!educationDetails.startMonth || !educationDetails.startYear)
      validationParams.startMonth = 'Start Date is required';
    else validationParams.startMonth = '';

    const expStartMonth =
      educationDetails.startMonth < 10
        ? '0' + educationDetails.startMonth
        : educationDetails.startMonth;

    const expEndMonth =
      educationDetails.endMonth < 10
        ? '0' + educationDetails.endMonth
        : educationDetails.endMonth;

    if (
      !educationDetails.currentlyStudying &&
      (!educationDetails.endMonth || !educationDetails.endYear)
    )
      validationParams.endMonth = 'End Date is required';
    else if (
      !educationDetails.currentlyStudying &&
      moment('01/' + expStartMonth + '/' + educationDetails.startYear).isAfter(
        '01/' + expEndMonth + '/' + educationDetails.endYear
      )
    ) {
      validationParams.endMonth = '';
      validationParams.startMonth =
        'Start Date should not greater than end date';
    } else {
      validationParams.endMonth = '';
      validationParams.startMonth = '';
    }

    setErrmsg(validationParams);
  }, [errMsg, educationDetails]);

  const handleSubmit = useCallback(() => {
    handleValidation();
    setEnableSubmit(!enableSubmit);
  }, [enableSubmit, handleValidation]);

  const editEducation = (data) => {
    educationDetails.schoolCollege = data.schoolCollege;
    educationDetails.degree = data.degree;
    educationDetails.fieldOfStudies = data.fieldOfStudies;
    educationDetails.startMonth = data.startDate?.split('/')?.[0];
    educationDetails.startYear = data.startDate?.split('/')?.[1];
    educationDetails.endMonth = data.endDate?.split('/')?.[0];
    educationDetails.endYear = data.endDate?.split('/')?.[1];
    educationDetails.otherDetails = data.otherDetails;
    educationDetails.currentlyStudying = data.currentlyStudying;
    setEducationId(data.id);
    changeAction(false, 'education');
    setEducatiobDetails((prevState) => ({
      ...prevState,
    }));
  };

  const onDeleteEducation = (deleteId) => {
    dispatch(deleteEducation(deleteId));
    changeAction(true, 'education');
    resetFields();
  };

  const educationAdd = () => {
    setEdit(true);
    setEducationId(null);
    changeAction(false, 'education');
    changeTitle('Add', 'education');
  };

  const backToEdit = () => {
    setEdit(false);
    changeAction(true, 'education');
    changeTitle('Edit', 'education');
  };

  const closeModal = () => {
    resetFields();
    onClose(false, 'education');
  };

  return (
    <>
      <BrandIconSpinner loading={loading} />
      <ExperienceContainer>
        <>
          {educationsData.action ? (
            <ExperienceList>
              {educationsData?.details?.length > 0 &&
                educationsData?.details?.map((data, index) => {
                  return (
                    <div key={index} className="show-exp-list">
                      <div className="exp-title">
                        <div className="role">{data.schoolCollege}</div>
                        <div className="exp-date">
                          {data.startDate +
                            ' ' +
                            (data.endDate ? `- ${data?.endDate}` : '- Present')}
                        </div>
                      </div>
                      <div className="sub-data-flex">
                        {data.degree}
                        {data.fieldOfStudies ? (
                          <>
                            <span> • </span> <div>{data.fieldOfStudies}</div>
                          </>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className="sub-data-flex">{data.otherDetails}</div>
                      <div className="icon-action">
                        <div
                          onClick={() => editEducation(data)}
                          className="edit-icon"
                        >
                          <BasicIconButton
                            icon={<EditFilled />}
                            ariaLabel={'edit-icon'}
                            size="small"
                          />
                        </div>
                        <BasicPopover
                          handlePopoverClick={() => setIsAlertPopoverOpen(true)}
                          isOpen={isAlertPopoverOpen}
                          action={
                            <div className="remove-icon">
                              <BasicIconButton
                                icon={<Delete />}
                                ariaLabel={'remove-icon'}
                                size="small"
                              />
                            </div>
                          }
                          content={
                            <JobAlertPopover className="job-alert-popover">
                              Are you sure you want to delete?
                              <div>
                                <Button
                                  variant="text"
                                  color="error"
                                  label="Yes"
                                  onClick={() => onDeleteEducation(data.id)}
                                />
                                <Button
                                  variant="text"
                                  label="No"
                                  onClick={() => setIsAlertPopoverOpen(false)}
                                />
                              </div>
                            </JobAlertPopover>
                          }
                        />
                      </div>
                    </div>
                  );
                })}
            </ExperienceList>
          ) : (
            <div className="profile-experience-container">
              <Input
                label={t('profile.SchoolName')}
                value={educationDetails.schoolCollege}
                onChange={(data) => handleChange(data, 'schoolCollege')}
                errMsg={errMsg.schoolCollege}
                required
              />
              <div className="field-wrap">
                <Input
                  label={t('profile.BoardDegree')}
                  value={educationDetails.degree}
                  onChange={(data) => handleChange(data, 'degree')}
                  errMsg={errMsg.degree}
                  required
                />
                <Input
                  label={t('profile.Field')}
                  value={educationDetails.fieldOfStudies}
                  onChange={(data) => handleChange(data, 'fieldOfStudies')}
                  errMsg={errMsg.fieldOfStudies}
                />
              </div>
              <div className="field-wrap">
                <div className="date-container">
                  <div className="lebelView">
                    <label>
                      {t('profile.StartDate')}
                      <span className="requiredSymbol">*</span>
                    </label>
                  </div>
                  <div className="date-select-field">
                    <div>
                      <Select
                        Options={MonthList}
                        value={educationDetails.startMonth}
                        onChange={(data) =>
                          handleChange(data.target.value, 'startMonth')
                        }
                      />
                      {errMsg.startMonth && (
                        <span className="errMsg">
                          <Exclamation />
                          {errMsg.startMonth}
                        </span>
                      )}
                    </div>
                    <Select
                      Options={YearList}
                      value={educationDetails.startYear}
                      onChange={(data) =>
                        handleChange(data.target.value, 'startYear')
                      }
                    />
                  </div>
                </div>
                {!educationDetails.currentlyStudying && (
                  <div className="date-container">
                    <div className="lebelView">
                      <label>
                        {t('profile.EndDate')}
                        <span className="requiredSymbol">*</span>
                      </label>
                    </div>
                    <div className="date-select-field">
                      <div>
                        <Select
                          Options={MonthList}
                          value={educationDetails.endMonth}
                          onChange={(data) =>
                            handleChange(data.target.value, 'endMonth')
                          }
                        />
                        {errMsg.endMonth && (
                          <span className="errMsg">
                            <Exclamation />
                            {errMsg.endMonth}
                          </span>
                        )}
                      </div>
                      <Select
                        Options={YearList}
                        value={educationDetails.endYear}
                        onChange={(data) =>
                          handleChange(data.target.value, 'endYear')
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
              <CheckBox
                label={t('profile.CurrentlyStudying')}
                onChange={(data) => handleChange(data, 'currentlyStudying')}
                value={educationDetails.currentlyStudying}
                size="small"
              />
              <Input
                label={t('profile.AnythingElse')}
                value={educationDetails.otherDetails}
                onChange={(data) => handleChange(data, 'otherDetails')}
                errMsg={errMsg.otherDetails}
                multiline
                minRows={5}
                maxLimit={200}
              />
            </div>
          )}
        </>
      </ExperienceContainer>
      <SubmitContainer className="modal-footer">
        {ProfileLimit.maxLimitProfile >=
          Number(educationsData?.details?.length || 0) && (
            <>
              {edit && (
                <Button
                  label={t('Back')}
                  customStyles={`add-new`}
                  onClick={backToEdit}
                  type="text"
                  startIcon={<BackArrow />}
                />
              )}
              {educationsData.action && (
                <Button
                  label={t('Add New')}
                  customStyles={`add-new`}
                  onClick={educationAdd}
                  type="text"
                />
              )}
              {!educationsData.action && (
                <Button
                  label={t(educationsData.action ? 'profile.Update' : 'profile.Save')}
                  onClick={handleSubmit}
                  type="text"
                />
              )}
            </>
          )}
        <Button label={t('profile.Close')} onClick={closeModal} type="text" />
      </SubmitContainer>
    </>
  );
};
export default Educations;
